import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationSubject = new Subject<{ status: 'success' | 'error', message: string }>();

  get notifications() {
    return this.notificationSubject.asObservable();
  }

  showSuccess(message: string) {
    this.notificationSubject.next({ status: 'success', message });
  }

  showError(message: string) {
    this.notificationSubject.next({ status: 'error', message });
  }
}
